<template>
  <div id="invoice-page">
    <div id="printMe2">
      <vx-card id="invoice-container">
        <table style="width: 100%" class="border-collapse">
          <tr>
            <td>
              <h6 style="text-align: center; font-size: 18px">
                Denizli Caner Otomotiv San. Tic. Ltd. Şti. Arızalı Ürün Onay
                Sistemi
              </h6>
              <h6>Onay Bekleyen İşlem Detayı</h6>
            </td>
          </tr>
        </table>

        <table border="1" style="border-top: 1px solid" class="border-collapse">
          <tr>
            <td>
              <table style="text-align: center">
                <tr>
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    İşlem
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    {{ islem }}
                  </td>
                </tr>
                <tr>
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    Fiş No
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    {{ fisNo }}
                  </td>
                </tr>

                <tr>
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    Form Kayıt Tarihi
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    {{ FTARIH }}
                  </td>
                </tr>

                <tr>
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    Müşteri
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    {{ musteri }}
                  </td>
                </tr>
                <tr>
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    Ürün Bilgisi
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    <table style="width: 100% !important; text-align: center">
                      <tr>
                        <th
                          sort-key="stokkodu"
                          style="
                            text-align: center;
                            border-bottom: 1px solid;
                            border-right: 1px solid;
                            padding: 3px;
                          "
                        >
                          Stok Kodu
                        </th>

                        <th
                          style="
                            text-align: center;
                            border-bottom: 1px solid;
                            border-right: 1px solid;
                            padding: 3px;
                          "
                        >
                          Stok Adı
                        </th>
                        <th
                          style="
                            text-align: center;
                            border-bottom: 1px solid;
                            border-right: 1px solid;
                            padding: 3px;
                          "
                        >
                          Adedi
                        </th>
                        <th
                          style="
                            text-align: center;
                            border-bottom: 1px solid;
                            
                            padding: 3px;
                          "
                        >
                          Tedarikçi Kodu
                        </th>
                      </tr>
                      <tr :key="indextr" v-for="(tr, indextr) in kalemListesi">
                        <td style="padding: 8px; border-right: 1px solid">
                          {{ tr.STOCKNO }}
                        </td>

                        <td style="padding: 8px; border-right: 1px solid">
                          {{ tr.STOCKNAME }}
                        </td>
                        <td style="padding: 8px; border-right: 1px solid">
                          {{ tr.SECILEN }} adet
                        </td>
                        <td style="padding: 8px; border-right: 1px solid">
                          {{ tr.SUPPSTOCKNO }}
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>

                <tr>
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    İade Nedeni
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    {{ iadeSebep }}
                  </td>
                </tr>

                <tr>
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    Açıklama
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    {{ aciklama }}
                  </td>
                </tr>

                <tr>
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    Ekler
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    <b-badge
                      style="float: left;"
                      :key="index"
                      v-for="(item, index) in resimlerList"
                    >
                      <img
                        style="width: 150px; margin-right: 8px"
                        v-bind:src="bindimage + item.URL"
                        class="grid-view-img px-4"
                        @click="resimBuyut(bindimage + item.URL)"
                      />
                    </b-badge>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <br />
        </table>

        <br />
      </vx-card>
    </div>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import userJson from "../../../../../public/user.json";
import moment from "moment";
export default {
  data() {
    return {
      islem: "",
      fisNo: "",
      musteri: "",
      iadeSekli: "",
      iadeSebep: "",
      aciklama: "",
      gonderen: "",
      dosya: "",
      FTARIH: "",
      MASRAF: "",
      resimlerList: [],
      bindimage: userJson.stockImage
    };
  },
  computed: {
    kalemListesi(kalemlist) { 
      return Store.state.account.iadeArizaKalemList;
    }
  },
  methods: {
    getItems(gelen, islem) {
      this.islem = islem;
      this.fisNo = gelen[0].RECEIPTNO;
      this.musteri = "DENİZLİ CANER OTOMOTİV SAN. TİC. LTD. ŞTİ.";
      this.iadeSekli =
        gelen[0].SPECCODE2 == "1"
          ? "Müşteri Kendisi"
          : gelen[0].SPECCODE2 == "2"
          ? "Seyahatte Alndı"
          : "Kargo / Ambar";
      this.iadeSebep = gelen[0].DESCRIPTION;
      this.aciklama = gelen[0].DESCRIPTION1;
      this.gonderen = gelen[0].DESCRIPTION2;
      const today = new Date();
      var TRANSDATE = moment(String(today)).format("DD.MM.YYYY");
      this.FTARIH = TRANSDATE;
      this.dosya =
        "http://canermail.uzum.com.tr?id=" +
        gelen[0].RECEIPTID +
        "&islem=" +
        gelen[0].RECEIPTTYPE;
      //http://crm.kamyonyedekparca.com/c2/ArizaUrunOnayla.aspx?Id=
     // this.kalemListesi(islem, gelen[0].RECEIPTID);
      this.getMasref(gelen[0].RECEIPTID);
      this.dosyaListesi(islem, gelen[0].RECEIPTID);
    },
    getMasref(RECEIPTID) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      var args = {
        token: Store.state.tokenId,
        RECEIPTID: RECEIPTID
      };
      soap.createClient(url, function(err, client) {
        client.INT_IadeArizaliUrunSepetMasraf(args, function(err, result) {
          if (result.INT_IadeArizaliUrunSepetMasrafResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vm.veriler = JSON.parse(
              result.INT_IadeArizaliUrunKalemListesiResult
            );
            vm.MASRAF = vm.veriler[0].TUTAR;
          } catch (error) {}
        });
      });
    },
    dosyaListesi(islem, RECEIPTID) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      var args = {
        token: Store.state.tokenId,
        ISLEM: islem,
        RECEIPTID: RECEIPTID
      };
      soap.createClient(url, function(err, client) {
        client.INT_IadeArizaliUrunEkler(args, function(err, result) {
          if (result.INT_IadeArizaliUrunEklerResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vm.veriler = JSON.parse(result.INT_IadeArizaliUrunEklerResult);
            vm.resimlerList = vm.veriler;
          } catch (error) {
            console.log(error);
          }
        });
      });
    }
  }
};
</script>
